import selectLocalExercise from './selectLocalExercise';
const selectXpLost = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return 0;
  }
  return localExercise.xpLost;
};
export default selectXpLost;